// Some cayenne params, like weightFrom/To, need >=/<=
const getComparator = (key) => {
    if (key.includes('From')) {
        return '>=';
    }
    if (key.includes('To')) {
        return '<=';
    }
    return '=';
};

const isFilterValueValid = (filterState, key) => {
    const value = filterState.applied[key];
    if (!Number.isNaN(Number(value)) && Number(value) === -1) {
        return false;
    }
    if (key === 'customFilters') {
        return false;
    }
    return value;
};

const getNullValueParam = (key, value, nullValue) => {
    const cayenneVal = value === nullValue ? 'null' : `${value}`;
    return `${key}=${cayenneVal}`;
};

// Status is represented in Cayenne as two different properties with boolean values so we need to reflect that here
const getStatusParam = (value) => {
    const key = value === 'active' ? 'active' : 'isInHallOfFame';
    return `${key}=1`;
};

// teamValue is a string (i.e. 'team.1')
const getTeamParam = (teamValue) => {
    const [grouping, value] = teamValue.split('.');
    const key = 'opponentFranchiseId';
    return `${key}=${value}`;
};

const checkIfDraftRoundIsNeeded = ({ draftYear, draftRound }) => {
    const isYearValid = draftYear && draftYear !== 'undrafted';
    return !draftRound && isYearValid;
};

export const encodePlayerName = (playerName, fieldName, isPlayerSearch = false) => {
    const formattedPlayer = playerName.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const encodedURI = encodeURIComponent(`${fieldName} likeIgnoreCase "%${formattedPlayer}%"`);
    /**
     * The player search and report api work a little different
     * The player search is fairly simple, it adds the query params to the ag request and gets a response
     * The report api adds the cayenneExp to the select context, then applies that to a where clause (ReportQueryBuilder)
     * To make sure the report api works, we add \\ before the '
     */
    return isPlayerSearch ? encodedURI : encodedURI.replace(/'/g, "\\\\'");
};

export default (filterState, reportCategory) => {
    const cayenneValues = Object.keys(filterState.applied)
        .filter((key) => isFilterValueValid(filterState, key))
        .map((key) => {
            const value = filterState.applied[key];

            if (key === 'playerSearch') {
                return reportCategory === 'goalie'
                    ? encodePlayerName(value, 'goalieFullName')
                    : encodePlayerName(value, 'skaterFullName');
            }

            if (key === 'opponent') {
                return encodeURIComponent(getTeamParam(value));
            }
            if (key === 'status') {
                return encodeURIComponent(getStatusParam(value));
            }
            if (key === 'draftYear') {
                return encodeURIComponent(getNullValueParam(key, value, 'undrafted'));
            }

            if (!key) {
                return '';
            }

            const comparator = getComparator(key);
            const cayenneVal = typeof value === 'string' ? `"${value}"` : value;

            return `${key}${comparator}${encodeURIComponent(cayenneVal)}`;
        })
        .filter((cayennExpString) => cayennExpString);

    // Add a draft round filter if draft year or pick is being filtered
    if (checkIfDraftRoundIsNeeded(filterState.applied)) {
        return [...cayenneValues, 'draftRound>=1'];
    }
    return cayenneValues;
};
